import { render, staticRenderFns } from "./FlatTable.vue?vue&type=template&id=49c916b2&scoped=true&"
import script from "./FlatTable.vue?vue&type=script&lang=ts&"
export * from "./FlatTable.vue?vue&type=script&lang=ts&"
import style0 from "./FlatTable.vue?vue&type=style&index=0&id=49c916b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c916b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VDataTable,VDivider,VPagination,VSkeletonLoader,VTextField})
